import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import {
  LinkComponentProps,
  LinkComponentType,
} from "@origin-digital/ods-types";

export const CustomLink: LinkComponentType = ({
  href,
  ...restProps
}: LinkComponentProps) => {
  if (href && href.startsWith("/")) {
    // ODS LinkComponentProps is not directly assignable to ReactRouterLink props;
    // cast is safe because the spread is type-checked at the call site by LinkComponentType.
    return <ReactRouterLink to={href} {...(restProps as any)} />;
  }
  return <a href={href} {...restProps} />;
};
